import { t } from "@/i18n-js/instance";
import type { StoredAttachment } from "../hooks/useAttachmentsUpload";
import type { ConversationChannel } from "../types/ConversationChannel";
import type { ConversationStatus } from "../types/ConversationStatus";
import { CircleBotFooterMessage } from "./common/CircleBotFooterMessage";
import { ConversationClosedFooter } from "./common/ConversationClosedFooter";
import { HelpInputArea } from "./common/HelpInputArea";

interface ConversationViewFooterProps {
  attachments: StoredAttachment[];
  channel: ConversationChannel | null;
  expectingButtonClick: boolean;
  isBotProcessing: boolean;
  onSendMessage: (text: string) => void;
  status: ConversationStatus | null;
  sunshineConversationId?: string;
  uploadAttachments: (files: File[]) => void;
}

export const ConversationViewFooter = ({
  attachments,
  channel,
  expectingButtonClick,
  isBotProcessing,
  onSendMessage,
  status,
  sunshineConversationId,
  uploadAttachments,
}: ConversationViewFooterProps) => {
  if (status === "closed") {
    return (
      <ConversationClosedFooter
        channel={channel}
        sunshineConversationId={sunshineConversationId}
      />
    );
  }

  return (
    <>
      <div className="bg-primary sticky bottom-0 z-10 mx-4 pb-3 pt-[2px]">
        <HelpInputArea
          onSubmit={onSendMessage}
          placeholder={t(
            "help_widget.conversation_page.help_input_placeholder",
          )}
          allowAttachments={channel !== "circle_bot"}
          uploadAttachments={uploadAttachments}
          attachments={attachments}
          isSubmitDisabled={isBotProcessing || expectingButtonClick}
        />
      </div>
      {channel === "circle_bot" && <CircleBotFooterMessage />}
    </>
  );
};
